export default "/images/vendor/flag-icon-css/flags/4x3/tn.svg?6cd8c9a453cd0fc5e7619a480e957d2d";